import React from "react"
import logo from "./logo.svg"

import { Outlet, ScrollRestoration, useLocation } from "react-router-dom"
import { Box, CssBaseline, Toolbar } from "@mui/material"
import {
  createTheme,
  responsiveFontSizes,
  ThemeProvider,
} from "@mui/material/styles"
import Landingpage from "../../pages/landingpage/Landingpage"
import NavBar from "./NavBar"
function App() {
  const location = useLocation()

  let theme = createTheme({
    palette: {
      // mode: "dark",
      // background: {
      //   default: "#1E212B", //Raisin Black
      //   paper: "#1E212B", //Raisin Black
      // },
      text: {
        primary: "#4C4D4D", //Davy's Gray
      },

      primary: {
        // light: "#ffe24d", //orangeYellowCrayola
        main: "#28A3D7", //Picton Blue
        // dark: "#bb8100", //chocolateWeb
        contrastText: "#000000",
      },
      // //this is used in navbar color
      // secondary: {
      //   light: "#ffe24d", //orangeYellowCrayola
      //   main: "#242423", //eerieBlack rgba(36,36,35)
      //   dark: "#bb8100", //chocolateWeb
      // },
    },
    typography: {
      fontFamily: ["Roboto Slab", "sans-serif"].join(","),
    },
  })

  theme = responsiveFontSizes(theme)

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ScrollRestoration />
        <NavBar />
        <Toolbar /> {/*empty toolbar to fill the space */}
        <Box>{location.pathname === "/" ? <Landingpage /> : <Outlet />}</Box>
      </ThemeProvider>
    </>
  )
}

export default App
